<template>
    <div class="main">
        <div class="title">
            <div>监测仪总数</div>
            <div>已绑定总数</div>
            <div>工作中</div>
            <div>离线</div>
            <div>人员总数</div>
        </div>
        <div class="num">
            <div>{{ tableData.deviceCnt }}</div>
            <div>{{ tableData.boundCnt }}</div>
            <div>{{ tableData.workingCnt }}</div>
            <div>{{ tableData.offlineCnt }}</div>
            <div>{{ tableData.userCnt }}</div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            tableData: [], // 数据
        }
    },
    mounted(){
        this.getTableData();
    },
    methods: {
        // 获取表格数据
        getTableData(){
            this.$get('/api/tenant/monitorStatus', {}, res => {
                if(res.code == 0){
                    if(res.data){
                        this.tableData = res.data;
                    }
                }else{
                    this.$message.error(res.msg);
                }
            }, err => {
                console.log(err);
                this.$message.error('服务端发生异常')
            })
        },
    }
}
</script>

<style lang='scss' scoped>
    .main{
        padding: 0 !important;
        border: 1px solid #E8E8E8;
        border-radius: 4px;
        .title{
            display: flex;
            text-align: center;
            background: #F0F0F0;
            div{
                flex: 1;
                height: 50px;
                line-height: 50px;
                border-right: 1px solid #E8E8E8;
            }
            div:last-child{
                border-right: none;
            }
        }
        .num{
            display: flex;
            text-align: center;
            div{
                flex: 1;
                height: 50px;
                line-height: 50px;
                border-right: 1px solid #E8E8E8;
            }
            div:last-child{
                border-right: none;
            }
        }
    }
</style>